module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12 row-rm-padding"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title pull-right"
  }, [_c('button', {
    staticClass: "btn primary-btn-my clear-new-modal",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.newModal = true
      }
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('md-dialog', {
    staticClass: "model_show_products",
    attrs: {
      "md-active": _vm.newModal
    },
    on: {
      "update:mdActive": function($event) {
        _vm.newModal = $event
      },
      "update:md-active": function($event) {
        _vm.newModal = $event
      }
    }
  }, [_c('md-dialog-title', {
    staticClass: "model-title"
  }, [_vm._v("Add new Product\n        "), _c('a', {
    staticClass: "md-primary",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.newModal = false
      }
    }
  }, [_c('md-icon', {
    staticClass: "close-btn",
    staticStyle: {
      "font-size": "18px !important"
    }
  }, [_vm._v("close\n          ")])], 1)]), _vm._v(" "), _c('form', {
    staticClass: "from_padding_product"
  }, [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-small-size-100"
  }, [_c('md-field', {
    class: _vm.getValidationClassNewForm('name')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Product Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "name",
      "id": "name"
    },
    model: {
      value: (_vm.newForm.name),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "name", $$v)
      },
      expression: "newForm.name"
    }
  }), _vm._v(" "), (!_vm.$v.newForm.name.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The Product Name is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.newForm.name.required && this.newFormBackendValidation.name.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.newFormBackendValidation.name.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClassNewForm('category_catalog_id')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Product Category")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "category_catalog_id",
      "id": "category_catalog_id"
    },
    model: {
      value: (_vm.newForm.category_catalog_id),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "category_catalog_id", $$v)
      },
      expression: "newForm.category_catalog_id"
    }
  }, _vm._l((_vm.categoryList), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")])
  }), 1), _vm._v(" "), (!_vm.$v.newForm.category_catalog_id.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The Product Category is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.newForm.category_catalog_id.required && this.newFormBackendValidation.category_catalog_id.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.newFormBackendValidation.category_catalog_id.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Product description")]), _vm._v(" "), _c('ckeditor', {
    model: {
      value: (_vm.descriptionArea),
      callback: function($$v) {
        _vm.descriptionArea = $$v
      },
      expression: "descriptionArea"
    }
  })], 1), _vm._v(" "), _c('div', [_c('uploader', {
    attrs: {
      "title": "Upload Images",
      "limit": "20",
      "autoUpload": false
    },
    on: {
      "on-change": _vm.onChange,
      "on-delete": _vm.onDelete
    },
    model: {
      value: (_vm.fileList),
      callback: function($$v) {
        _vm.fileList = $$v
      },
      expression: "fileList"
    }
  })], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClassNewForm('selectedPrimary')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Select Primary Image")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "selectedPrimary",
      "id": "selectedPrimary"
    },
    model: {
      value: (_vm.newForm.selectedPrimary),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "selectedPrimary", $$v)
      },
      expression: "newForm.selectedPrimary"
    }
  }, _vm._l((_vm.Imagelenght), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_vm._v("\n                    Image " + _vm._s(item + 1) + "\n                  ")])
  }), 1), _vm._v(" "), (!_vm.$v.newForm.selectedPrimary.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The selectedPrimary is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.newForm.selectedPrimary.required && this.newFormBackendValidation.selectedPrimary.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.newFormBackendValidation.selectedPrimary.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('md-field', {
    class: _vm.getValidationClassNewForm('attributes')
  }, [(_vm.tableHeadersSelected.length != 0) ? _c('label', {
    staticClass: "multiLable"
  }, [_vm._v("Select the table headers")]) : _vm._e(), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "Select the table headers",
      "placeholder": "Select the table headers",
      "label": "name",
      "track-by": "id",
      "options": _vm.headerList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "input": function($event) {
        return _vm.changeTable()
      }
    },
    model: {
      value: (_vm.tableHeadersSelected),
      callback: function($$v) {
        _vm.tableHeadersSelected = $$v
      },
      expression: "tableHeadersSelected"
    }
  }), _vm._v(" "), (!_vm.$v.newForm.attributes.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The table headers is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.newForm.attributes.required && this.newFormBackendValidation.attributes.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.newFormBackendValidation.attributes.errorMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.columns.length > 0) ? _c('div', [_c('button', {
    staticClass: "btn primary-btn-my add_row",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addRowModal = true
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', {
    staticClass: "thead_style"
  }, [_c('tr', [_vm._l((_vm.columns), function(column, index) {
    return _c('th', {
      key: index
    }, [_vm._v(" " + _vm._s(column.name))])
  }), _vm._v(" "), _c('th', [_vm._v("Actions")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item, index) {
    return _c('tr', {
      key: index
    }, [_vm._l((_vm.columns), function(column, indexColumn) {
      return _c('td', {
        key: indexColumn
      }, [_vm._v(_vm._s(item[column.slug]))])
    }), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info btn-sm btn-modal-edit",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editRow(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("\n                       "), _c('button', {
      staticClass: "btn btn-danger btn-sm btn-delete",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteRow(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 2)
  }), 0)])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-spaces"
  }), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-container"
  }, [_c('button', {
    staticClass: "btn primary-btn-my custom-modal-footer-items",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.validateSubmission()
      }
    }
  }, [_vm._v("\n             Add Product\n           ")]), _vm._v("   \n           "), _c('button', {
    staticClass: "btn primary-btn-my custom-modal-footer-items",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.validateSubmission('stay')
      }
    }
  }, [_vm._v("\n             Add & Create Another One\n           ")]), _vm._v("   \n              \n           "), _c('button', {
    staticClass: "btn default_btn-my custom-modal-footer-items",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearNewForm
    }
  }, [_vm._v("\n             Clear Form\n           ")]), _vm._v(" "), _c('sync-loader', {
    staticClass: "custom-modal-footer-items",
    attrs: {
      "loading": _vm.newModalLoading,
      "color": _vm.newModalColor,
      "size": _vm.newModalSize,
      "width": _vm.newModalWidth,
      "margin": _vm.newModalMargin
    }
  })], 1)])], 1), _vm._v(" "), _c('md-dialog', {
    staticClass: "model_show_products",
    attrs: {
      "md-active": _vm.editModal
    },
    on: {
      "update:mdActive": function($event) {
        _vm.editModal = $event
      },
      "update:md-active": function($event) {
        _vm.editModal = $event
      }
    }
  }, [_c('md-dialog-title', {
    staticClass: "model-title"
  }, [_vm._v("Edit Product\n        "), _c('a', {
    staticClass: "md-primary",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_c('md-icon', {
    staticClass: "close-btn",
    staticStyle: {
      "font-size": "18px !important"
    }
  }, [_vm._v("close\n          ")])], 1)]), _vm._v(" "), _c('form', {
    staticClass: "from_padding_product"
  }, [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-small-size-100"
  }, [_c('md-field', {
    class: _vm.getValidationClassEditForm('name')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Product Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "name": "name",
      "id": "name"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  }), _vm._v(" "), (!_vm.$v.editForm.name.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The Product Name is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.editForm.name.required && this.editFormBackendValidation.name.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.editFormBackendValidation.name.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClassEditForm('category_catalog_id')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Product Category")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "category_catalog_id",
      "id": "category_catalog_id"
    },
    model: {
      value: (_vm.editForm.category_catalog_id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "category_catalog_id", $$v)
      },
      expression: "editForm.category_catalog_id"
    }
  }, _vm._l((_vm.categoryList), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")])
  }), 1), _vm._v(" "), (!_vm.$v.editForm.category_catalog_id.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The Product Category is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.editForm.category_catalog_id.required && this.editFormBackendValidation.category_catalog_id.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.editFormBackendValidation.category_catalog_id.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Product description")]), _vm._v(" "), _c('ckeditor', {
    model: {
      value: (_vm.descriptionArea),
      callback: function($$v) {
        _vm.descriptionArea = $$v
      },
      expression: "descriptionArea"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('p', [_vm._v("Uploaded Images")]), _vm._v(" "), _c('ul', {
    staticClass: "up_image_list"
  }, _vm._l((_vm.uploadedImageList), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('div', {
      staticClass: "dd_img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "deleteBtn",
      on: {
        "click": function($event) {
          return _vm.deleteImage(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)]), _vm._v(" "), _c('div', [_c('uploader', {
    attrs: {
      "title": "Upload Images",
      "limit": "20",
      "autoUpload": false
    },
    on: {
      "on-change": _vm.onChange,
      "on-delete": _vm.onDelete
    },
    model: {
      value: (_vm.fileList),
      callback: function($$v) {
        _vm.fileList = $$v
      },
      expression: "fileList"
    }
  })], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClassEditForm('selectedPrimary')
  }, [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Select Primary Image")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "selectedPrimary",
      "id": "selectedPrimary"
    },
    model: {
      value: (_vm.editForm.selectedPrimary),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "selectedPrimary", $$v)
      },
      expression: "editForm.selectedPrimary"
    }
  }, _vm._l((_vm.Imagelenght), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item
      }
    }, [_vm._v("\n                    Image " + _vm._s(item + 1) + "\n                  ")])
  }), 1), _vm._v(" "), (!_vm.$v.editForm.selectedPrimary.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The selectedPrimary is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.editForm.selectedPrimary.required && this.editFormBackendValidation.selectedPrimary.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.editFormBackendValidation.selectedPrimary.errorMsg))]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('md-field', {
    class: _vm.getValidationClassEditForm('attributes')
  }, [(_vm.tableHeadersSelected.length != 0) ? _c('label', {
    staticClass: "multiLable"
  }, [_vm._v("Select the table headers")]) : _vm._e(), _vm._v(" "), _c('multiselect', {
    attrs: {
      "tag-placeholder": "Select the table headers",
      "placeholder": "Select the table headers",
      "label": "name",
      "track-by": "id",
      "options": _vm.headerList,
      "multiple": true,
      "taggable": true
    },
    on: {
      "input": function($event) {
        return _vm.changeTable()
      }
    },
    model: {
      value: (_vm.tableHeadersSelected),
      callback: function($$v) {
        _vm.tableHeadersSelected = $$v
      },
      expression: "tableHeadersSelected"
    }
  }), _vm._v(" "), (!_vm.$v.editForm.attributes.required) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("The table headers is required")]) : _vm._e(), _vm._v(" "), (_vm.$v.editForm.attributes.required && this.editFormBackendValidation.attributes.isError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(this.editFormBackendValidation.attributes.errorMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.columns.length > 0) ? _c('div', [_c('button', {
    staticClass: "btn primary-btn-my add_row",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addRowModal = true
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', {
    staticClass: "thead_style"
  }, [_c('tr', [_vm._l((_vm.columns), function(column, index) {
    return _c('th', {
      key: index
    }, [_vm._v(" " + _vm._s(column.name))])
  }), _vm._v(" "), _c('th', [_vm._v("Actions")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item, index) {
    return (item.status === '1') ? _c('tr', {
      key: index
    }, [_vm._l((_vm.columns), function(column, indexColumn) {
      return _c('td', {
        key: indexColumn
      }, [_vm._v(_vm._s(item[column.slug]))])
    }), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info btn-sm btn-modal-edit",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editRow(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v("\n                       "), _c('button', {
      staticClass: "btn btn-danger btn-sm btn-delete",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteRow(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 2) : _vm._e()
  }), 0)])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-spaces"
  }), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-container"
  }, [_c('button', {
    staticClass: "btn primary-btn-my custom-modal-footer-items",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.validateSubmission
    }
  }, [_vm._v("\n              Update Product\n            ")]), _vm._v("\n               \n            "), _c('sync-loader', {
    staticClass: "custom-modal-footer-items",
    attrs: {
      "loading": _vm.editModalLoading,
      "color": _vm.editModalColor,
      "size": _vm.editModalSize,
      "width": _vm.editModalWidth,
      "margin": _vm.editModalMargin
    }
  })], 1)])], 1), _vm._v(" "), _c('md-dialog', {
    staticClass: "model-show-new",
    attrs: {
      "md-active": _vm.addRowModal
    },
    on: {
      "update:mdActive": function($event) {
        _vm.addRowModal = $event
      },
      "update:md-active": function($event) {
        _vm.addRowModal = $event
      }
    }
  }, [_c('md-dialog-title', {
    staticClass: "model-title modal-width-100"
  }, [_vm._v("Add new Row\n        "), _c('a', {
    staticClass: "md-primary",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.addRowModal = false
      }
    }
  }, [_c('md-icon', {
    staticClass: "close-btn",
    staticStyle: {
      "font-size": "18px !important"
    }
  }, [_vm._v("close\n          ")])], 1)]), _vm._v(" "), _c('form', {
    staticClass: "from-padding modal-width-100"
  }, [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-small-size-100"
  }, [_vm._l((_vm.tableHeadersSelected), function(item) {
    return _c('md-field', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_c('label', {
      staticClass: "lable-fileds"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('md-input', {
      attrs: {
        "name": "no",
        "id": "no",
        "autocomplete": "no"
      },
      model: {
        value: (_vm.rowItems[item.slug]),
        callback: function($$v) {
          _vm.$set(_vm.rowItems, item.slug, $$v)
        },
        expression: "rowItems[item.slug]"
      }
    })], 1)
  }), _vm._v(" "), _c('md-field', [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Type")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "type_id",
      "id": "type_id"
    },
    model: {
      value: (_vm.rowItems.type_id),
      callback: function($$v) {
        _vm.$set(_vm.rowItems, "type_id", $$v)
      },
      expression: "rowItems.type_id"
    }
  }, _vm._l((_vm.tableTypeList), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('md-field', [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Colors")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "colors",
      "id": "colors",
      "multiple": ""
    },
    model: {
      value: (_vm.rowItems.colors),
      callback: function($$v) {
        _vm.$set(_vm.rowItems, "colors", $$v)
      },
      expression: "rowItems.colors"
    }
  }, _vm._l((_vm.colourList), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")])
  }), 1)], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-spaces"
  }), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-container"
  }, [_c('button', {
    staticClass: "btn primary-btn-my custom-modal-footer-items",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addNewRow
    }
  }, [_vm._v("\n               Add Row\n             ")])])])], 1), _vm._v(" "), _c('md-dialog', {
    staticClass: "model-show-new",
    attrs: {
      "md-active": _vm.updateRowModal
    },
    on: {
      "update:mdActive": function($event) {
        _vm.updateRowModal = $event
      },
      "update:md-active": function($event) {
        _vm.updateRowModal = $event
      }
    }
  }, [_c('md-dialog-title', {
    staticClass: "model-title modal-width-100"
  }, [_vm._v("Update Row\n        "), _c('a', {
    staticClass: "md-primary",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.updateRowModal = false
      }
    }
  }, [_c('md-icon', {
    staticClass: "close-btn",
    staticStyle: {
      "font-size": "18px !important"
    }
  }, [_vm._v("close\n          ")])], 1)]), _vm._v(" "), _c('form', {
    staticClass: "from-padding modal-width-100"
  }, [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-small-size-100"
  }, [_vm._l((_vm.tableHeadersSelected), function(item) {
    return _c('md-field', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_c('label', {
      staticClass: "lable-fileds"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('md-input', {
      attrs: {
        "name": "no",
        "id": "no",
        "autocomplete": "no"
      },
      model: {
        value: (_vm.editRowItems[item.slug]),
        callback: function($$v) {
          _vm.$set(_vm.editRowItems, item.slug, $$v)
        },
        expression: "editRowItems[item.slug]"
      }
    })], 1)
  }), _vm._v(" "), _c('md-field', [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Type")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "type_id",
      "id": "type_id"
    },
    model: {
      value: (_vm.editRowItems.type_id),
      callback: function($$v) {
        _vm.$set(_vm.editRowItems, "type_id", $$v)
      },
      expression: "editRowItems.type_id"
    }
  }, _vm._l((_vm.tableTypeList), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('md-field', [_c('label', {
    staticClass: "lable-fileds"
  }, [_vm._v("Colors")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "colors",
      "id": "colors",
      "multiple": ""
    },
    model: {
      value: (_vm.editRowItems.colors),
      callback: function($$v) {
        _vm.$set(_vm.editRowItems, "colors", $$v)
      },
      expression: "editRowItems.colors"
    }
  }, _vm._l((_vm.colourList), function(item) {
    return _c('md-option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")])
  }), 1)], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-spaces"
  }), _vm._v(" "), _c('div', {
    staticClass: "custom-modal-footer-container"
  }, [_c('button', {
    staticClass: "btn primary-btn-my custom-modal-footer-items",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateRowData
    }
  }, [_vm._v("\n               Update Row\n             ")])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "example1_length"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "tableData"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "aria-label": "Rendering engine: activate to sort column descending",
      "aria-sort": "ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Date\n                      ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "aria-label": "Browser: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Product Name\n                      ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "aria-label": "Browser: activate to sort column ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("Product category\n                      ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "tabindex": "0"
    }
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff632b82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/admin/ProductCatalogProduct.vue
// module id = 2123
// module chunks = 1